import { copyTextToClipboard, truncateString } from '@capsicum/common';
import { Text } from '@capsicum/common-web';
import styled from 'styled-components';

export const CopyableAddress = ({ address, textAbove }: { address: string; textAbove: string }) => (
	<div>
		<S.TextAbove variant="text1">{textAbove}</S.TextAbove>
		<S.Address
			onClick={() => {
				copyTextToClipboard(address);
			}}
		>
			{truncateString(address, 8, 8)}
		</S.Address>
	</div>
);

namespace S {
	export const TextAbove = styled(Text)`
		text-align: end;
	`;
	export const Address = styled.span`
		display: inline-block;
		cursor: pointer;
		${({ theme }) => theme.fonts.text.text1};
		color: ${({ theme }) => theme.colors.borders.brand.enabled};
	`;
}
